import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ThfLookupFilter } from '@totvs/thf-ui';

import { ThfPageJobSchedulerService } from './thf-page-job-scheduler.service';

@Injectable()
export class ThfPageJobSchedulerLookupService implements ThfLookupFilter {

  constructor(private thfPageJobSchedulerService: ThfPageJobSchedulerService) { }

  getFilteredData(search: string, page: number, pageSize: number): Observable<any> {
    const params = { page, pageSize, search };

    return this.thfPageJobSchedulerService.getProcesses(params);
  }

  getObjectByValue(processId: string): Observable<any> {
    return this.thfPageJobSchedulerService.getProcess(processId);
  }

}
